import { LogoApi } from "pages/Survey/api";
import { useEffect, useState } from "react";

const Logo = () => {
  const [logoSrc, setLogoSrc] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const data = await LogoApi.getLogo();
        setLogoSrc(data.url);
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error(error);
        }
      }
    })();
  }, []);

  return (
    <div className="surveyLogo">
      {logoSrc && (
        <img
          src={logoSrc}
          alt="Люмі-Дент"
          className="surveyLogoImage"
        />
      )}
    </div>
  );
};

export default Logo;
